import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./comentarios.component.html")

angular.module("appModule").component("comentarios", {
  templateUrl: templateUrl,
  bindings: {
    modelId: "<",
    model: "<",
    refresh: "<"
  },
  controller: [
    "ComentarioService",
    "permissionService",
    function ComentariosController(ComentarioService, permissionService) {
      var self = this

      self.modelName = "comentarioGenerico"

      self._columns = [
        {
          key: "comment",
          value: "comentario"
        },
        {
          key: "autor",
          value: "ingresado por"
        },
        {
          key: "fecha_ingreso",
          value: "fecha"
        },
        {
          key: "modelName",
          value: "tipo"
        }
      ]

      self.menuOptions = [
        {
          name: "Eliminar",
          callback: "deleteRow"
        }
      ]

      self.crudMenu = [
        {
          action: "crear",
          icon_name: "add",
          callback: "create"
        },
        {
          action: "eliminar",
          icon_name: "delete",
          callback: "delete"
        }
      ]

      if (!permissionService.eliminarComentarios()) {
        self.menuOptions.splice(-1, 1)
        self.crudMenu.splice(-1, 1)
      }

      self.onCreate = function(post_data, callback) {
        var comment = {
          object_pk: self.modelId,
          modelName: self.model,
          comment: post_data
        }

        return ComentarioService.save(comment).$promise.then(function(data) {
          return data
        })
      }

      // self.onEdit = function(models){
      //   return ComentarioService.updateAlertas(models);
      // };

      self.onDelete = function(models) {
        // return ComentarioService.remove({id: models[0]}).$promise.then(function(data){
        //   return data;
        // });
        return ComentarioService.remove({ "ids[]": models }).$promise
      }

      self._getModels = function() {
        return ComentarioService.query({
          model_id: self.modelId,
          model_name: self.model
        }).$promise.then(function(data) {
          return data
        })
      }
    }
  ]
})
